import styled from 'styled-components'

import { breakpoint, space } from 'app/theme/tokens'

export const Container = styled.div``

/**
 * ScheduleWrapper width is intentionally wider than the viewport on desktop
 * (120vw) so the horizontal scroll surfaces all schedule columns. On mobile
 * that turns into an unusable double-axis scroll — switch to 100% width and
 * let the page-level vertical scroll handle long days.
 */
export const ScheduleWrapper = styled.div`
  padding: 10px 30px 0px 30px;
  width: 120vw;

  ${breakpoint.down('tablet')} {
    width: 100%;
    padding: ${space.sm} ${space.md} 0 ${space.md};
  }
`

export const NewFlowWrapper = styled.div`
  padding: 10px 30px 0px 30px;

  ${breakpoint.down('tablet')} {
    padding: ${space.sm} ${space.md} 0 ${space.md};
  }
`
